import { useField } from 'react-final-form';

import { Textarea, TextareaProps } from '@oaknorth/component-core-v2';

import { FormFieldWrapper } from './FormFieldWrapper';
import { FormFieldProps } from './types';

export interface TextareaFieldProps
  extends FormFieldProps,
    Omit<TextareaProps, 'value' | 'name' | 'id' | 'isInvalid' | 'onChange' | 'onBlur'> {
  onChange?: (newValue: string) => void;
}

export const TextareaField = ({ fieldName, labelText, helperText, onChange, ...props }: TextareaFieldProps) => {
  const {
    input,
    meta: { error, touched },
  } = useField<string | null | undefined>(fieldName);

  return (
    <FormFieldWrapper
      fieldName={fieldName}
      labelText={labelText}
      helperText={helperText}
      error={error}
      touched={touched}
    >
      <Textarea
        {...input}
        {...props}
        value={input.value || ''}
        name={fieldName}
        id={fieldName}
        onChange={(event) => {
          input.onChange(event);
          onChange?.(event.target.value);
        }}
      />
    </FormFieldWrapper>
  );
};
